export default __webpack_public_path__ + "static/project-slide-3-1248-765-696ba6fa1db9706e1f531e30d99c9285.webp";